import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import Layout from '../assets/warren-si.png';
import SystemControl from '../assets/equipment/3.18-system-control-panel.png';
import InspectionMonitor from '../assets/equipment/3.19-inspection-monitor.png';
import HMI from '../assets/equipment/3.20-HMI-panel.png';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { BsPencil } from 'react-icons/bs';
import PDPDrawing from '../../../../components/Tables/Tabledata/Drawings/IE-2470-110.pdf';

import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAssemblies = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('HMI');

	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>System Control</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 equipment-element">
								<Tab eventKey="HMI" title="HMI">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>HMI (HUMAN MACHINE INTERFACE)</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>
												The Human Machine Interface (<b>HMI</b>) is the primary operator interface for monitoring and controlling inspection. There is a stack light mounted on top of the monitor that, when illuminated, indicates a system status.
											</p>

											<p>A Green Light indicates that SMARTInspect is running and the system has not faulted. A Yellow/Amber Light indicates a system fault that does not stop the conveyor (Camera Faults, Server faults, minor PLC faults (non-safety related)). A Red Light/Horn indicates a system fault that has caused the conveyor to stop (Production Stop, Major PLC Faults/Comms Faults causing safety to be disrupted).</p>

											<p>The monitor displays all defect information captured with the scanners in the inspection cell. The vision system can identify and categorize each defect including its location, size, and type. This system collects data that can be analyzed for actionable insights so you can optimize your processes.</p>

											<p>
												The PowerPaint <b>HMI</b> is the interface through which the user can access data about the system, look up diagnostic information, check service logs, Start/Stop scanning process, and more. This control center also routes physical connections and power to the Inspection Cell.
											</p>
										</div>

										<div class="right-side">
											<figure style={{ width: '42vw', margin: '20px' }}>
												<img src={SystemControl} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Human Machine Interface (HMI)</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Buttons and Indicators" title="Buttons and Indicators">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>BUTTONS AND INDICATORS</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>
												The console <b>HMI</b> includes several hardwired pushbuttons including a Prod-Stop for additional controls.
											</p>
											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Name</th>

														<th>Function</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>Silence Alarms Pushbutton</td>

														<td>Silences the alarm horn when pressed.</td>
													</tr>
													<tr>
														<td>Fault Reset Pushbutton</td>

														<td>Resets active fault when pressed.</td>
													</tr>
													<tr>
														<td>
															Conveyor By-Pass
															<br />
															Keyed Switch
														</td>

														<td>Allows the operator to place the conveyor to the cell in By-pass or In-cycle mode.</td>
													</tr>
													<tr>
														<td>Production Stop Pushbutton</td>

														<td>Press to immediately stop all machine motion. Servo power is disabled.</td>
													</tr>
												</tbody>
											</Table>
										</div>

										<div class="right-side">
											<figure style={{ width: '40vw', margin: '20px' }}>
												<img src={HMI} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: HMI Buttons</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Inspection Monitor" title="Inspection Monitor">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>INSPECTION MONITOR (MON)</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<ol>
												<li class="mb-3">A unit approaching the finesse deck enters the data queue once the unit reaches the entering prox. If the AVI barcode is not able to be read, data will not be displayed on the monitors for that unit.</li>
												<li class="mb-3">If the monitor data is populating too early or too late in a specific station the monitor window values can be changed.</li>
												<li class="mb-3">In powerpaint, go to configuration (top right) then click ‘monitor window setup’.</li>
												<li class="mb-3">A table will be displayed, correspond each row to a Monitor number (labeled on each J-box on the back of each display.</li>
												<li class="mb-3">The editable numeric values in the table correspond to a count in seconds of how long the deck conveyor has been moving while the unit has been on the deck.</li>
												<li class="mb-3">The first monitor window is from 0-70, so immediately after the unit enters the deck its data will be displayed AS SOON AS the unit ahead of it is out of range, a unit that has been on the deck for a count of 60 will be displayed in the 0-70 window until it achieves a count of 71, at which point the next highest count unit will be displayed if present.</li>
											</ol>
										</div>

										<div class="right-side">
											<figure style={{ width: '45vw', margin: '20px' }}>
												<img src={InspectionMonitor} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Inspection Monitors</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
